import React from "react";
import { Card, CardBody, Button, Tooltip } from "@heroui/react";
import { Icon } from "@iconify/react";
import { TRequest } from "@shared/entities";

interface TransportersListProps {
	transporters?: TRequest["transporters"];
}

export const TransportersList: React.FC<TransportersListProps> = ({ transporters = [] }) => {
	return (
		<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
			{transporters.map((transporter, index) => {
				const document = transporter.document;

				return (
					<Card key={index} className="bg-content2">
						<CardBody>
							<div className="flex items-center gap-3">
								<div className="bg-primary-100 text-primary p-2 rounded-full">
									<Icon icon="lucide:truck" className="h-5 w-5" />
								</div>
								<div className="flex-grow">
									<h3 className="font-medium">{transporter.fullName}</h3>
									<p className="text-default-500 text-sm">ת.ז: {transporter.idNumber}</p>
								</div>
								{!!document && (
									<div className="flex gap-1">
										<Tooltip content="הורד תעודת זהות">
											<Button
												isIconOnly
												size="sm"
												variant="light"
												as="a"
												href={document.url}
												target="_blank"
												rel="noopener noreferrer"
											>
												<Icon icon="lucide:download" className="h-4 w-4" />
											</Button>
										</Tooltip>
										<Tooltip content="צפה בתעודת זהות">
											<Button
												isIconOnly
												size="sm"
												variant="light"
												as="a"
												href={document.url}
												target="_blank"
												rel="noopener noreferrer"
											>
												<Icon icon="lucide:eye" className="h-4 w-4" />
											</Button>
										</Tooltip>
									</div>
								)}
							</div>
						</CardBody>
					</Card>
				);
			})}
		</div>
	);
};
